// extracted by mini-css-extract-plugin
export default {"main":"LevelCard_main__Va1am","wrapper":"LevelCard_wrapper__nFjgM","tag":"LevelCard_tag__HTZs6","mainAc":"LevelCard_mainAc__OY2KW","example":"LevelCard_example__o+StB"};